<div class="ark-sidenav-header row m-0">
  <div class="col ark-sidenav-header-container">
    <i class="fas fa-history"></i>
    <h2 class="ark-h2">
      <span class="ark-sidenav-tittle">{{ title }}</span>
    </h2>
  </div>

  <div class="col col-auto p-0 d-flex justify-content-end align-items-center">
    <a class="btn ark-btn-action close" (click)="onCloseModal()">
      <span><i class="fal fa-times"></i></span>
    </a>
  </div>
</div>

<div class="ark-sidenav-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col col-12">
        <div class="container">
          <ul class="list-group container-list">
            @for (item of history; track item.url) {
              <li class="list-group-item-history">
                <div class="d-flex align-items-center">
                  <div class="col-md-9 icon-link-container">
                    <i [ngClass]="getIconClass(item.url)" class="icon"></i>
                    <a (click)="navigateToRoute($event, item.url)">{{ item.url }}</a>
                  </div>
                  <div class="col-md-3 time-ago-container">
                    <i class="far fa-copy mr-4" (click)="copyUrl(item.url)"></i>
                    <app-time-ago [dateTime]="item.dateTimeVisited"></app-time-ago>
                  </div>
                </div>
              </li>
            }
          </ul>
        </div>
        @if(history && history.length === 0){
          <tk-fallback-view
            [type]="'section'"
            [message]="'general.NoRoutesNavigationHistory' | translate"
            [imageSrc]="'assets/img/ark-icon-empty-section.svg'">
          </tk-fallback-view>
        }
      </div>
    </div>
  </div>
</div>
